import React, { useState, useEffect, useContext, Fragment, useCallback } from 'react';
import { Input, Table, Avatar, message, Modal, Tag,Button} from "antd";
import { PlusOutlined, SettingTwoTone, ExclamationCircleOutlined } from '@ant-design/icons';
import WscDictMapping from "@/component/dictmapping";
import useWscTableList from '@/component/UseWscTableList';
import useWscCustomFormModal from '@/component/UseWscCustomForm';
import useWscCustomColumns from '@/component/UseWscCustomColumns';
import useRequest from '@/utils/useRequest';
import { useCommonStore } from "@/store/useCommonStore";
import ColumnSettings from '@/component/ColumnSettings';
import _ from "lodash";
import DeptTree from './dept';

const { Search } = Input;

const initParams = {
  pagination: {
    current: 1,
    pageSize: 10
  },
  filters: {
    userType: 0,
  },
  sorter: null
};


const Userlist = (props) => {
  const { request } = useRequest();
  const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
  const { list, isLoading, pagination, setPage, setFilter, filters, setSorter, Refresh } = useWscTableList({
    //appid:"crttcserver",
    url: "/api/v2/private/user/list", initParams: initParams
  });

  const { Refresh: refreshColumns, colsettings } = useWscCustomColumns({ key: "user" });
  const [columns, setColumns] = useState([]);
  const areatree = useCommonStore.use.areatree();
  useEffect(() => {
    if (colsettings) {

      let cols = colsettings?.filter(item => item.visible).concat(ExtendColumns);

      let col = cols.find(item => item.dataIndex == "CustomerRoles");
      if (col) {
        col.render = (roles) => {

          let ReactTag = roles.map((item, index) => {
            let color = "green";
            switch (item.Id) {
              case 2:
                color = "blue";
                break;
              case 1:
                color = "#2db7f5";
                break;

            }
            return (<Tag key={index} color={color}>{item.Name}</Tag>);
          });
          return (<div>{ReactTag}</div>);
        }
      }
      let col1 = cols.find(item => item.dataIndex == "IDType");
      if (col1) {
        col1.render = (at) => {

          return <WscDictMapping dictName={"IDTypes"} dictValue={at} />;
        };
      }

      let col2 = cols.find(item => item.dataIndex == "HeadImgUrl");
      if (col2) {
        col2.render = (text) => {
          if (!text || text == "null") {
            return (<Avatar style={{ height: "32px", width: "32px" }} src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />);
          }
          return (<Avatar style={{ height: "32px", width: "32px" }} src={text} />)
        };
      }      
      setColumns(cols);
    }
  }, [colsettings]);

  const ExtendColumns = [
    {
      title: <div>操作 <ColumnSettings topic="user" colsettings={colsettings} list={list} onFinish={refreshColumns} /></div>,
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => {
        // console.log('Id, item, idx', Id, idx, item)
        console.log("record", record)
        return (
          <Fragment>
            <Button //mode={"hide"} 
              type='link' onClick={async () => {
                let area = [];
                let b = [];
                const deepSearch = (tree, key) => {
                  for (var i = 0; i < tree.length; i++) {
                    area.push(tree[i].Id);
                    if (tree[i].Id == key) {
                      b = _.clone(area);
                      return
                    }
                    if (tree[i].children && tree[i].children.length > 0) {
                      deepSearch(tree[i].children, key);
                    }
                    area.pop();
                  }
                }
                deepSearch(areatree, record.AreaId);
                
                console.log("b", b)
               
                showDynamicModal(53, { ...record, Area: b, Roles: record.CustomerRoles.map(i => i.Id), });
              }}>修改</Button>
            <Button 
              //mode={"hide"}
              type='link' onClick={async () => {
                Modal.confirm({
                  title: '确认删除',
                  icon: <ExclamationCircleOutlined />,
                  content: '您确定删除此用户么？',
                  onOk: async () => {
                    let result = await request("/api/v2/private/user/delete", "POST", "json", { id: record.Id });
                    if (result.success) {
                      message.success(result.message);
                      Refresh();
                    } else {
                      Modal.error({ content: result.message });
                    }
                  },
                  okText: '确认',
                  cancelText: '取消',
                });

              }}>删除</Button>
          </Fragment>
        );
      },
    },
  ];

  const handleTableChange = (pagination, _filters, sorter) => {
    setPage(pagination.current);
    setFilter({ ...filters, ..._filters });
    setSorter(sorter);
  }

  return (
    <div style={{ maxHeight: 'calc(100vh - 120px)', overflowY: 'scroll' }} className='bg-white pl-4 pb-4'>
      <div className="flex flex-row mb-4 items-center justify-between">
        <div className="flex flex-row items-center mt-4">
          <span className="text-base text-gray-800 font-bold mr-4">查询</span>
          <div>
            <Search placeholder="请输入查询内容" onSearch={(val) => {
              setFilter({ ...filters, keywords: val });
            }} enterButton />
          </div>
        </div>
        <Button className='mr-4 mt-4' onClick={() => {
          setFilter(initParams.filters);
          setPage(1);
        }}>
          重置
        </Button>
      </div>
      <Button 
        //mode={"hide"}
        className="mb-4" type="primary" icon={<PlusOutlined />} onClick={() => {
          showDynamicModal(51, {});
        }}>
        新增
      </Button>
      <div className="flex h-full flex-row">
        <div className='w-1/5'>
        <DeptTree  onChange={(val, left, right) => {
          setFilter({ ...filters, Dept: { id: val, left, right } });
        }} />
        </div>
        <Table
          className="w-4/5 h-full mr-4"
          rowKey={"Id"}
          loading={isLoading}
          bordered
          dataSource={list}
          columns={columns}
          pagination={pagination}
          onChange={handleTableChange}
          size="small"
        />
      </div>
      <WscCustomFormModal formId={51} OnPayload={(form, name, payload) => {
        if (name == "OK") {
          if (payload.apiresult?.success == false) {
            Modal.error({ content: payload.apiresult.message });
            return;
          } else {
            message.success(payload.apiresult?.message);
            hide(51);
            Refresh();
            return;
          }
        }
        if (name == "Cancel") {
          hide(51);
          return;
        }
      }
      }
      />
      <WscCustomFormModal formId={53} OnPayload={(form, name, payload) => {
        if (name == "OK") {
          if (payload.apiresult?.success == false) {
            Modal.error({ content: payload.apiresult.message });
            return;
          } else {
            message.success(payload.apiresult?.message);
            hide(53);
            Refresh();
            return;
          }
        }
        if (name == "Cancel") {
          hide(53);
          return;
        }
      }
      }
      />
    </div>
  );
}

export default Userlist;